import { MAX_CHARACTERS_ALLOWED_TO_SUBMIT } from '#pplx/frontend/components/utils/consts.js';
export function getSubmissionPolicy({ draftLength, disableSubmission = false, disableInput = false, hasError = false, needsMoreModels = false, requireAttachment = false, hasAttachment = false, hasPendingUploads = false, hasFailedSelectedFile = false, }) {
    return (disableSubmission ||
        disableInput ||
        hasError ||
        needsMoreModels ||
        (requireAttachment && !hasAttachment && !hasPendingUploads) ||
        draftLength > MAX_CHARACTERS_ALLOWED_TO_SUBMIT ||
        hasFailedSelectedFile);
}
//# sourceMappingURL=getSubmissionPolicy.js.map